import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    Renderer2,
    HostListener,
    OnDestroy,
} from "@angular/core";
import { ROUTES } from "./sidebar-items";
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
    public sidebarItems: any[];
    public innerHeight: any;
    public bodyTag: any;
    listMaxHeight: string;
    listMaxWidth: string;
    userFullName: string;
    userImg: string;
    userType: string;
    headerHeight = 60;
    currentRoute: string;
    routerObj = null;
    menuIcon = "radio_button_checked";
    permissions: any[] = [];

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public elementRef: ElementRef,
        private authService: AuthService,
        private router: Router
    ) {
        const body = this.elementRef.nativeElement.closest("body");
        this.routerObj = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // close sidebar on mobile screen after menu select
                this.renderer.removeClass(this.document.body, "overlay-open");
            }
        });
    }

    getUserPermissions(): any[] {
        const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
        return Array.isArray(userPermissions) ? userPermissions : [];
    }

    private filterSidebarItemsByPermission(routes: any[], userPermissions: any[]): any[] {
        return routes
            .map(item => {
                // If groupTitle, always include (for section headers)
                if (item.groupTitle) return item;
                // If no submenu, check permission on this item
                if (!item.submenu || item.submenu.length === 0) {
                    if (!item.rightKey) return item; // If no rightKey, show to all
                    const hasPermission = userPermissions.some(p => p.screen_name === item.rightKey);
                    return hasPermission ? item : null;
                }
                // If has submenu, filter submenu recursively
                const filteredSubmenu = this.filterSidebarItemsByPermission(item.submenu, userPermissions);
                if (filteredSubmenu.length > 0) {
                    return { ...item, submenu: filteredSubmenu };
                }
                return null;
            })
            .filter(Boolean);
    }

    @HostListener("window:resize", ["$event"])
    windowResizecall(event) {
        this.setMenuHeight();
        this.checkStatuForResize(false);
    }
    @HostListener("document:mousedown", ["$event"])
    onGlobalClick(event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.renderer.removeClass(this.document.body, "overlay-open");
        }
    }
    callToggleMenu(event: any, length: any) {
        if (length > 0) {
            const parentElement = event.target.closest("li");
            const activeClass = parentElement.classList.contains("active");

            if (activeClass) {
                this.renderer.removeClass(parentElement, "active");
            } else {
                this.renderer.addClass(parentElement, "active");
            }
        }
    }
    ngOnInit() {
        if (this.authService.currentUserValue) {
            this.userFullName = this.authService.currentUserValue.user.name;
            this.userImg = this.authService.currentUserValue.user.photo;
            this.userType = "Admin";
            this.permissions = this.getUserPermissions();
            this.sidebarItems = this.filterSidebarItemsByPermission(ROUTES, this.permissions);
        }


        this.initLeftSidebar();
        this.bodyTag = this.document.body;
    }
    ngOnDestroy() {
        this.routerObj.unsubscribe();
    }
    initLeftSidebar() {
        const _this = this;
        // Set menu height
        _this.setMenuHeight();
        _this.checkStatuForResize(true);
    }
    setMenuHeight() {
        this.innerHeight = window.innerHeight;
        const height = this.innerHeight - this.headerHeight;
        this.listMaxHeight = height + "";
        this.listMaxWidth = "500px";
    }
    isOpen() {
        return this.bodyTag.classList.contains("overlay-open");
    }
    checkStatuForResize(firstTime) {
        if (window.innerWidth < 1170) {
            this.renderer.addClass(this.document.body, "ls-closed");
        } else {
            this.renderer.removeClass(this.document.body, "ls-closed");
        }
    }
    mouseHover(e) {
        const body = this.elementRef.nativeElement.closest("body");
        if (body.classList.contains("submenu-closed")) {
            this.renderer.addClass(this.document.body, "side-closed-hover");
            this.renderer.removeClass(this.document.body, "submenu-closed");
        }
    }
    mouseOut(e) {
        const body = this.elementRef.nativeElement.closest("body");
        if (body.classList.contains("side-closed-hover")) {
            this.renderer.removeClass(this.document.body, "side-closed-hover");
            this.renderer.addClass(this.document.body, "submenu-closed");
        }
    }
    mobileMenuSidebarOpen(event: any, className: string) {
        const hasClass = event.target.classList.contains(className);
        if (hasClass) {
            this.renderer.removeClass(this.document.body, className);
        } else {
            this.renderer.addClass(this.document.body, className);
        }
    }
    callSidemenuCollapse() {
        const hasClass = this.document.body.classList.contains("side-closed");
        if (hasClass) {
            this.renderer.removeClass(this.document.body, "side-closed");
            this.renderer.removeClass(this.document.body, "submenu-closed");
            this.menuIcon = "radio_button_checked";
        } else {
            this.renderer.addClass(this.document.body, "side-closed");
            this.renderer.addClass(this.document.body, "submenu-closed");
            this.menuIcon = "radio_button_unchecked";
        }

        const sideClosedHover =
            this.document.body.classList.contains("side-closed");
        if (sideClosedHover) {
            this.renderer.removeClass(this.document.body, "side-closed-hover");
        }
    }
    logout() {
        this.authService.logout().subscribe((res) => {
            if (!res.success) {
                this.router.navigate(["/authentication/signin"]);
            }
        });
    }
}
